export function paginateCollectionItems<T>(input: { items: T[]; page: number; pageSize: number }): {
  currentPage: number;
  items: T[];
  pageCount: number;
} {
  const pageCount = Math.max(1, Math.ceil(input.items.length / input.pageSize));
  const currentPage = Math.min(Math.max(1, input.page), pageCount);
  const start = (currentPage - 1) * input.pageSize;
  return {
    currentPage,
    items: input.items.slice(start, start + input.pageSize),
    pageCount,
  };
}
